export { compare as compareCustomisations } from './customisations/compare.mjs';
export { defaults as defaultCustomisations, mergeCustomisations } from './customisations/index.mjs';
export { toBoolean } from './customisations/bool.mjs';
export { alignmentFromString, flipFromString } from './customisations/shorthand.mjs';
export { rotateFromString } from './customisations/rotate.mjs';
export { stringToIcon, validateIcon as validateIconName } from './icon/name.mjs';
export { iconDefaults as defaultIconData, fullIcon as fullIconData, matchName as matchIconName } from './icon/index.mjs';
export { mergeIconData } from './icon/merge.mjs';
export { isVariation, parseIconSet } from './icon-set/parse.mjs';
export { validateIconSet } from './icon-set/validate.mjs';
export { quicklyValidateIconSet } from './icon-set/validate-basic.mjs';
export { expandIconSet } from './icon-set/expand.mjs';
export { minifyIconSet } from './icon-set/minify.mjs';
export { getIcons } from './icon-set/get-icons.mjs';
export { getIconData } from './icon-set/get-icon.mjs';
export { convertIconSetInfo } from './icon-set/convert-info.mjs';
export { iconToSVG } from './svg/build.mjs';
export { replaceIDs } from './svg/id.mjs';
export { calculateSize } from './svg/size.mjs';
export { encodeSvgForCss } from './svg/encode-svg-for-css.mjs';
export { trimSVG } from './svg/trim.mjs';
export { colorKeywords } from './colors/keywords.mjs';
export { colorToString, compareColors, stringToColor } from './colors/index.mjs';
export { mergeIconProps } from './loader/utils.mjs';
export { getCustomIcon } from './loader/custom.mjs';
export { searchForIcon } from './loader/modern.mjs';
export { loadIcon } from './loader/loader.mjs';
export { camelToKebab, camelize, pascalize, snakelize } from './misc/strings.mjs';
import 'debug';
